
import type { PropType } from 'vue'
import type { Location } from 'vue-router'
import type {
  EpbButtonColor,
  EpbButtonIconPosition,
  EpbButtonSize,
  EpbButtonType,
} from './epb-button.types'
import { computed, defineComponent } from 'vue'
import { EpbLoading } from '../epb-loading'

export default defineComponent({
  name: 'EpbButton',
  components: {
    EpbLoading,
  },
  props: {
    type: {
      type: String as PropType<EpbButtonType>,
      default: 'cta',
    },
    color: {
      type: String as PropType<EpbButtonColor>,
      default: 'primary',
    },
    size: {
      type: String as PropType<EpbButtonSize>,
      default: 'normal',
    },
    label: {
      type: String,
      default: undefined,
    },
    icon: {
      type: String,
      default: undefined,
    },
    iconPosition: {
      type: String as PropType<EpbButtonIconPosition>,
      default: 'left',
    },
    to: {
      type: Object as PropType<Location>,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  setup(props, ctx) {
    const baseClass = 'epb-button'

    const classes = computed<Array<string | Record<string, boolean>>>(() => {
      const hasLabel = !!props.label || !!ctx.slots.default
      const hasIcon = !!props.icon
      return [
        baseClass,
        `${baseClass}--type-${props.type}`,
        `${baseClass}--color-${props.color}`,
        `${baseClass}--size-${props.size}`,
        {
          [`${baseClass}--with-icon`]: hasIcon && hasLabel,
          [`${baseClass}--with-icon-${props.iconPosition}`]: hasIcon && hasLabel,
          [`${baseClass}--icon`]: hasIcon && !hasLabel,
          [`${baseClass}--disabled`]: props.disabled,
          [`${baseClass}--selected`]: props.selected,
          [`${baseClass}--loading`]: props.loading,
        },
      ]
    })

    function click(event: MouseEvent): void {
      if (!props.disabled && !props.loading) {
        ctx.emit('click', event)
      }
    }

    return {
      baseClass,
      classes,
      click,
    }
  },
})
